import { WarningOutlined } from '@core/ui';
import { BroadcastDialog } from '../BroadcastDialog';
import { PopupProps } from './types';

export const Popup = ({ open, onClose, title, children, isCloseFunctionality, hasWarning }: PopupProps) => {
    if (!open) {
        return <></>;
    }

    return (
        <BroadcastDialog open={open} onClose={onClose} isCloseFunctionality={isCloseFunctionality}>
            {hasWarning && <WarningOutlined classNames="w-22 fill-warning mb-4" />}
            <h2 className="font-medium font-accent text-2xl md:text-[1.7rem]">{title}</h2>
            <div className="py-5 flex justify-start popup-inner">{children}</div>
        </BroadcastDialog>
    );
};
